import { Container, Hidden, Box, Divider } from "@mui/material/"
import { Icon } from "@mdi/react"
import { mdiCart } from "@mdi/js"

import Button from "components/Buttons/Button"
import Price, { TaxString } from "components/Price"
import ChangeAmountButton from "components/Buttons/ChangeAmountButton"

import useScrollPosition from "hooks/useScrollPosition"
import useTranslation from "hooks/useTranslation"

import { makeStyles } from "makeStyles"

import { ProductDetailPageReducerState } from "@secureo/common/reducers/productDetailPageReducer"

const useStyles = makeStyles()(() => ({
	flexGrid: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
	},
	priceAndAddToCart: {
		width: "40%",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
	},
	item1: {
		width: "35%",
	},
	item2: {
		display: "flex",
		width: "65%",
	},
	oldPrice: {
		fontSize: "12px",
		textDecoration: "line-through",
		color: "lightgrey",
	},
	fadeBg: {
		position: "fixed",
		top: 0,
		left: 0,
		width: "100%",
		zIndex: 5,
		boxShadow: "0px 2px 5px 0px rgba(0,0,0,0.15)",
		paddingTop: "10px",
		paddingBottom: 0,
		background: "#f7fafa",
	},
	dNone: {
		display: "none",
	},
	accLink: {
		width: "25%",
		textAlign: "center",
		paddingTop: "5px",
		paddingBottom: "8px",
		textDecoration: "none",
		color: "black",
		"&:hover": {
			background: "whitesmoke",
		},
	},
}))

const StickyProductInfo = ({ reducerState, addToCart, setQuantity }: Props) => {
	const { classes } = useStyles()
	const { scrollY } = useScrollPosition()
	const { t } = useTranslation("product")

	const {
		name,

		// Price
		quantity,
		singleGrossPriceCents,

		// Msrp price
		singleGrossMsrpPriceCents,
		attributes: { configurationGroups = [] },
	} = reducerState

	return (
		<Hidden mdDown>
			<div className={scrollY > 700 ? "" : classes.dNone}>
				<div className={classes.fadeBg}>
					<Container>
						<div className={classes.flexGrid}>
							<div className="h4">{name}</div>
							<div className={classes.priceAndAddToCart}>
								<div className={classes.item1}>
									{singleGrossMsrpPriceCents && (
										<div className={classes.oldPrice}>
											<Price priceInEuroCents={singleGrossMsrpPriceCents} />
										</div>
									)}
									<div style={{ display: "flex", alignItems: "center" }}>
										<h4 style={{ margin: "0" }}>
											<Price priceInEuroCents={singleGrossPriceCents} />
										</h4>
										<Box ml={1} className="small" style={{ color: "grey" }}>
											<TaxString />
										</Box>
									</div>
								</div>
								<div className={classes.item2}>
									{
										<>
											<Box mr={1}>
												<ChangeAmountButton
													quantity={quantity}
													onChange={setQuantity}
												/>
											</Box>
											<Button color="cart" onClick={addToCart}>
												{t("addToCart")}
												<Icon path={mdiCart} size={0.7} />
											</Button>
										</>
									}
								</div>
							</div>
						</div>
						<Box mt={1}>
							<Divider />
						</Box>
						<div
							style={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
							}}
						>
							<a href="#productinformation" className={classes.accLink}>
								{t("productInformation")}
							</a>
							{configurationGroups.length > 0 && (
								<a href="#configuration" className={classes.accLink}>
									{t("configure")}
								</a>
							)}
							<a href="#ratings" className={classes.accLink}>
								{t("ratings")}
							</a>
							<a href="#faq" className={classes.accLink}>
								FAQ
							</a>
						</div>
					</Container>
				</div>
			</div>
		</Hidden>
	)
}

interface Props {
	reducerState: ProductDetailPageReducerState
	setQuantity: (quantity: number) => void
	addToCart: () => void
}

export default StickyProductInfo
